<script>
	export default {
		name: 'VoucherExecuter',
		methods: {
			getVoucher(code) {
				const self_ = this;

				if(self_.isFalse(code)) { return }

				return self_.getFirestoreDocument('vouchers', code)
			},
			setVoucher(code, name, point, startDate, endDate, criteriumCode, criteriumName, status) {
				const self_ = this;

				const voucher_ = {
					name: name,
					point: point,
					startDate: startDate,
					endDate: endDate,
					criteriumCode: criteriumCode,
					criteriumName: criteriumName,
					status: status
				}

				return self_.setFirestoreDocument('vouchers', code, voucher_)
			},
			deleteVoucher(code) {
				const self_ = this;
				return self_.deleteFirestoreDocument('vouchers', code)
			}
		}
	}
</script>
